import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Spinner } from "../../components/Spinner";
import { ErrorMessage } from "../../components/Error/ErrorMessage";

import "./style.css";
import { ReportCardTable } from "./ReportCardTable";
import { CustomSelect } from "../../components/CustomSelect";
import {
  fetchReportCard,
  fetchAllReportCards,
  fetchAllSemesters,
} from "../../store/reportCardSlice";
import bookImage from "../../assets/images/book-img.svg";

export const ReportCard = () => {
  const { reportCardsStatus, reportCardsError } = useSelector(
    (state) => state.reportCards
  );
  const dispatch = useDispatch();
  let allSemesters = useSelector((state) => state.reportCards.semesters);
  if (allSemesters !== undefined) {
    allSemesters = [...allSemesters, 0];
  }
  const averageSemesterGrade = useSelector(
    (state) => state.reportCards.reportCards.average
  );
  const userToken = useSelector((state) => state.auth.userToken);
  const [semesterValue, setSemesterValue] = useState({
    value: 0,
    label: "Все семестры",
  });
  useEffect(() => {
    dispatch(fetchAllReportCards(userToken));
    dispatch(fetchAllSemesters(userToken));
  }, [userToken, dispatch]);

  if (reportCardsStatus === "loading") {
    return <Spinner type="points" text="Идёт загрузка" />;
  }

  if (reportCardsError) {
    return <ErrorMessage error={reportCardsError} />;
  }

  return (
    <>
      <div className="statistic-blocks">
        <CustomSelect
          options={allSemesters.map((semester) => ({
            value: semester,
            label: semester === 0 ? "Все семестры" : semester + " семестр",
          }))}
          onChange={(e) => {
            e.value === 0
              ? dispatch(fetchAllReportCards(userToken))
              : dispatch(
                  fetchReportCard({ token: userToken, semester: e.value })
                );
            setSemesterValue({ value: e.value, label: e.label });
          }}
          defaultValue={semesterValue}
          placeholder="Выберите семестр"
          label="Cеместр"
          semester={semesterValue.value}
        />
        <div className="statistic-block">
          <div>
            <h3 className={semesterValue.value === 0 ? "grade" : "description"}>
              {semesterValue.value === 0
                ? averageSemesterGrade && averageSemesterGrade.toFixed(2)
                : "*Отметка по практике учитывается при начислении стипендии в следующем семестре"}
            </h3>
            <div className="grade-description">
              {semesterValue.value === 0 ? "Общий средний балл" : ""}
            </div>
          </div>
          <div>
            <img src={bookImage} alt="Book icon" />
          </div>
        </div>
      </div>
      <ReportCardTable />
    </>
  );
};
